var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-google-analytics"},[_c('edit',{attrs:{"fs":_vm.googleAnalyticsFields,"api":"settings","id":"google-analytics","title":"Google Analytics Setting"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }